import request from "@/utils/request";
import { ouchnCustom } from "@/service";

// bannber列表
export function bannerList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/bannerList",
    method: "get",
    params: query,
  });
}
// 新书速递列表
export function goodsList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/goodsList",
    method: "get",
    params: query,
  });
}
// 好书推荐
export function goodBookList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/goodBookList",
    method: "get",
    params: query,
  });
}
// 猜你喜欢-未登录
export function getGuessFavouriteNoLogin(query) {
  return request({
    url: ouchnCustom + "/web/goods/getGuessFavouriteNoLogin",
    method: "get",
    params: query,
  });
}
// 猜你喜欢-已登录
export function getGuessFavouriteForLogin(query) {
  return request({
    url: ouchnCustom + "/web/goods/getGuessFavouriteForLogin",
    method: "get",
    params: query,
  });
}
// 首页查询热门图书
export function homePageselHotBookList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selHotBookList",
    method: "get",
    params: query,
  });
}
// 特色专题
export function selSubjectList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selSubjectList",
    method: "get",
    params: query,
  });
}
// 首页查询优秀作者
export function selAuthorList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selAuthorList",
    method: "get",
    params: query,
  });
}
// 查询合作机构
export function selDeptList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selDeptList",
    method: "get",
    params: query,
  });
}
// 新闻详情
export function selectNewsById(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selectNewsById",
    method: "get",
    params: query,
  });
}
// 搜索图书
export function selectBooks(query) {
  return request({
    url: ouchnCustom + "/web/serch/selectBooks",
    method: "get",
    params: query,
  });
}
// 搜索专题
export function selectSubjects(query) {
  return request({
    url: ouchnCustom + "/web/serch/selectSubjects",
    method: "get",
    params: query,
  });
}
// 搜索作者
export function selectAuthors(query) {
  return request({
    url: ouchnCustom + "/web/serch/selectAuthors",
    method: "get",
    params: query,
  });
}
// 搜索机构
export function selectInst(query) {
  return request({
    url: ouchnCustom + "/web/serch/selectInst",
    method: "get",
    params: query,
  });
}
// 底部导航
export function TofootNav(type) {
  return request({
    url: ouchnCustom + "/web/api/homePage/selectNewsByType?type=" + type,
    method: "get",
  });
}

// 获取考试token
export function paperGetToken() {
  return request({
    url: ouchnCustom + "/web/paper/getToken",
    method: "get",
  });
}

//获取活页式教材系统token
export function looseleafGetToken() {
  return request({
    url: ouchnCustom + "/web/looseleaf/getToken",
    method: "get",
  });
}

//web查询系统参数配置
export function getConfigKey() {
  return request({
    url: ouchnCustom + "/web/config/getConfigKey",
    method: "get",
  });
}
// 获取可添加积分的次数
export function GetInsertNumber(query) {
  return request({
    url: ouchnCustom + "/Integral/insertIntegralsg",
    method: "get",
    params: query,
  });
}

// 阅读时添加积分
export function InsertIntegrals(query) {
  return request({
    url: ouchnCustom + "/Integral/insertIntegrals",
    method: "get",
    params: query,
  });
}

// 获取试卷id
export function getPaperIdApi() {
  return request({
    url: ouchnCustom + "/device/paper/getPaperId",
    method: "GET",
  });
}

//获取推荐列表
export function getHomePageList() {
  return request({
    url: ouchnCustom + "/web/api/homePage/getHomePageList",
    method: "GET",
  });
}

export function getCatalogList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/getCatalogList",
    method: "GET",
    params: query,
  });
}
// http://124.133.23.84:10000/ouchn-customapi/web/api/homePage/getCatalogList?featuredId=1695034624738201600

// 更新试卷Id
export function updatePaperId(data) {
  return request({
    url: ouchnCustom + "/device/paper/updatePaperId",
    method: "POST",
    data,
  });
}
export function getResourceList(query) {
  return request({
    url: ouchnCustom + "/web/api/homePage/getResourceList",
    method: "GET",
    params: query,
  });
}

// bannber列表
export function getBannerList(query) {
  return request({
    url: ouchnCustom + "/device/api/homePage/bannerList",
    method: "get",
    params: query,
  });
}
// http://124.133.23.84:10000/ouchn-customapi/web/api/homePage/getResourceList?featuredId=1695034624738201600&catalogId=1695069415361613824
